import {Box, Typography} from "@mui/material";
import React from "react";

export interface ResponseMessage {
    title: string;
    body: string;
}

export const ResponseErrorAlert: React.FC<ResponseMessage> = ({title, body}) => {
    return (
        <Box>
            <Typography variant={"h6"}>{title}</Typography>
            <Typography variant={"body1"}>{body}</Typography>
        </Box>
    );
};
